import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h3, paragraphRegular } from '@helpers/typography';
import { SectionWrapperCSS, SectionWrapperInnerCSS, } from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import BreadcrumbsStyles from '@stories/Widgets/Global/Breadcrumbs/Breadcrumbs.styles';
import styled, { createGlobalStyle } from 'styled-components';
const WrapperStyles = createGlobalStyle `
  :root {
    .resource-banner-wrapper {
      ${SectionWrapperCSS};

      --bgAngle: 180deg !important;
      --titleHighlight: ${brand.secondary.ice};

      margin-top: calc(var(--headerHeight, 0px) * -1);
      padding-top: var(--headerHeight, 0px);
      overflow: clip;
      position: relative;
    }

    .resource-banner-inner {
      ${SectionWrapperInnerCSS};
      ${baseGrid};

      row-gap: 40px;

      div[id^='react_Components'] {
        grid-column: 1 / -1;

        @media ${from(Device.TabletLarge)} {
          grid-column: 1 / span 6;
        }

        @media ${from(Device.DesktopLarge)} {
          grid-column: 1 / span 5;
        }
      }
    }

    .resource-banner-form-container {
      border-radius: 24px;
      padding: ${fluid(40, 48)} ${fluid(16, 48)};
    
      @media ${from(Device.TabletLarge)} {
        grid-column: 7 / span 6;
      }
    }
  }
`;
const LeftContent = styled.div `
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  position: relative;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 5;

    [data-no-media='true'] & {
      grid-column: 3 / span 8;
    }
  }

  ${BreadcrumbsStyles.Container} {
    margin-bottom: ${fluid(16, 22)};
  }
`;
const FloatingElements = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  user-select: none;
  overflow: hidden;
`;
const Title = styled.h1 `
  ${h3};

  margin-bottom: ${fluid(16, 24)};
  color: ${brand.primary.white};
  line-height: 1.25;

  span {
    background: var(--titleHighlight, currentColor);
    background-clip: text;
    color: transparent;
    display: inline;
  }
`;
const Content = styled.div `
  ${paragraphRegular};
  color: ${brand.primary.white};
  margin-bottom: ${fluid(40, 45)};
`;
export const PremiumResourceBannerStyles = {
    Content,
    FloatingElements,
    LeftContent,
    Title,
    WrapperStyles,
};
